import { render, staticRenderFns } from "./ScenarioInstitutionsTab.vue?vue&type=template&id=7f5532ad"
import script from "./ScenarioInstitutionsTab.vue?vue&type=script&lang=js"
export * from "./ScenarioInstitutionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports